import React, { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useOnUpdate } from 'js/customHooks'
import 'styles/controls/ParameterSwitch.sass';


//Cambiar a universeSwitch

export default function ParameterSwitch() {
  const universes = useSelector((state) => state.universes);
  const universe = useSelector((state) => state.universe);
  const dispatch = useDispatch();

  useEffect(() => { 
    console.log('render ParametersSwitch')
  });

  return (
    <div id="parChartCont" className="table">
      <div className="row">
        <div className="cell">
          <div id="parCont" className="table">
            <div className="row relative">
              {Object.keys(universes).length == 0 && 
                <div className="parItem cell">
                  <div id={'XIcon'} className={"parItemSel"} />
                </div>
              }
              {Object.keys(universes).map((u) => (
                <div className="parItem cell" onClick={() => {dispatch({ type: 'SET_UNIVERSE', payload: u})}} title={u.charAt(0) + u.slice(1).toLowerCase() + " Ocean"}>
                  <div id={u+'Icon'} className={u==universe?"parItemSel":"parItemUnSel"} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
